#import "../fragments/landing-page-full-fragment.graphql"

mutation UpdatePage($input: PageUpdateInput!) {
    pageUpdate(input: $input) {
        page {
            ...LandingPageFullFragment
        }
    }
}
